export default __webpack_public_path__ + "static/media/background-4.e867a4dd.jpg";